import React from "react";

import { formatBrandName, formatLabels } from "../Helpers/formatters";

// Static Brand Icon Assets
import klsLogo from "../Assets/icons/KLS16.png";
import pdcLogo from "../Assets/icons/PDC16.png";
import pisLogo from "../Assets/icons/PISfav.ico";
import sfLogo from "../Assets/icons/SF16.png";
import sprLogo from "../Assets/icons/SPR16.png";
import prrLogo from "../Assets/icons/PRR16.svg";
import qprLogo from "../Assets/icons/QPR16.svg";
import pfLogo from "../Assets/icons/PF16.png";

const renderBrand = (brand, logo) => (
  <span className={formatLabels(brand)} style={{marginRight: "1rem"}}>
    {formatBrandName(brand)}
    <img src={logo} alt={`${logo.toLowerCase()} logo`}></img>
  </span>
);

const BrandIcon = ({ brandId }) => {
  if (!brandId) return null;
  const setIcon = (brand) => {
    switch (brand) {
      case 1:
        return renderBrand("KLS", klsLogo);
      case 2:
        return renderBrand("SF", sfLogo);
      case 3:
        return renderBrand("PDC", pdcLogo);
      case 4:
        return renderBrand("PIS", pisLogo);
      case 5:
        return renderBrand("SPR", sprLogo);
      case 6:
        return renderBrand("PRR", prrLogo);
      case 7:
        return renderBrand("QPR", qprLogo);
      case 8:
        return renderBrand("PF", pfLogo);
      default:
        return;
    }
  };
  return setIcon(brandId);
};

export default BrandIcon;
